module.exports = __webpack_public_path__ + "img/bai-user-weixin.6023be88.png";